import { useMemo, useState } from 'react'
import { useNavigate } from 'react-router'

import { CommandPalette } from './chat/CommandPalette'
import { ConversationView } from './chat/ConversationView'
import { ShortcutHelp } from './chat/ShortcutHelp'
import { Sidebar } from './chat/Sidebar'
import { AppShell } from './components/AppShell'
import { UserHeaderActions } from './components/UserHeaderActions'
import { useShortcuts } from './hooks/useShortcuts'

/**
 * Uygulama kabugu: sidebar + konusma gorunumu.
 *
 * Guard'lar burada DEGIL: `routes.tsx` bu ekrani `<Private>` icinde render
 * ediyor. Ekran basina guard yazmak, birini atlamanin en olasi yolu.
 *
 * Akis da burada DEGIL: `<StreamManager>` router'in USTUNDE ve gezinme
 * uretimi yikmiyor. Bu kisit P4'un en onemli yapisal karari.
 */
export function ChatScreen() {
  const navigate = useNavigate()
  const [drawerOpen, setDrawerOpen] = useState(false)
  const [palette, setPalette] = useState(false)
  const [help, setHelp] = useState(false)

  // Kisayol nesnesi MEMOIZE: `useShortcuts` onu dependency olarak izliyor ve
  // her render'da yeni nesne vermek dinleyiciyi surekli sokup takmak demek.
  const shortcuts = useMemo(
    () => ({
      onPalette: () => setPalette(true),
      onNewChat: () => {
        navigate('/')
        setDrawerOpen(false)
      },
      onToggleSidebar: () => setDrawerOpen((open) => !open),
      onHelp: () => setHelp(true),
      onEscape: () => {
        // Sirali kapatma: en ustteki pencere once. Ikisini birden kapatmak
        // kullanicinin tek `Esc` ile iki adim geri gitmesi olurdu.
        if (help) setHelp(false)
        else if (palette) setPalette(false)
        else if (drawerOpen) setDrawerOpen(false)
      },
    }),
    [navigate, help, palette, drawerOpen],
  )
  useShortcuts(shortcuts)

  return (
    <AppShell
      drawerOpen={drawerOpen}
      onToggleDrawer={() => setDrawerOpen((open) => !open)}
      onCloseDrawer={() => setDrawerOpen(false)}
      headerActions={<UserHeaderActions />}
      sidebar={<Sidebar onNavigate={() => setDrawerOpen(false)} />}
    >
      <ConversationView />
      {palette && <CommandPalette onClose={() => setPalette(false)} />}
      {help && <ShortcutHelp onClose={() => setHelp(false)} />}
    </AppShell>
  )
}

